// O QUE A TELA PODE DIZER ENQUANTO UM ENVIO LONGO RODA.
//
// A carga inicial, o retorno da folha e o "processar recebidos" respondem só
// no fim: a competência entra inteira ou não entra (T069), então não há
// resposta parcial que virasse porcentagem. Até 10/09/2026 as três telas
// mostravam só "Enviando…" num botão, e uma carga de 2.600 servidores levava
// mais de meia hora em homologação — o operador não sabia se estava vivo.
//
// Aqui o que se afirma é o que se sabe: continua esperando, há quanto tempo,
// quanto costuma levar e por que não fechar a página. Sem inventar progresso.

import { useEffect, useState } from "react";

/** Segundos desde que `ativo` virou true; zera quando vira false. */
export function useSegundosDecorridos(ativo: boolean): number {
  const [segundos, setSegundos] = useState(0);
  useEffect(() => {
    if (!ativo) return;
    setSegundos(0);
    const inicio = Date.now();
    const id = window.setInterval(() => setSegundos(Math.floor((Date.now() - inicio) / 1000)), 1000);
    return () => window.clearInterval(id);
  }, [ativo]);
  return ativo ? segundos : 0;
}

export function fmtDecorrido(segundos: number): string {
  return `${Math.floor(segundos / 60)}:${String(segundos % 60).padStart(2, "0")}`;
}

export function AndamentoEnvio({
  ativo,
  verbo = "Processando",
  expectativa = "Uma base de alguns milhares de servidores leva em torno de um minuto.",
  consequencia = "Não feche esta página: o envio entra inteiro ou não entra, e o resultado aparece aqui no fim.",
}: {
  ativo: boolean;
  /** "Processando", "Validando", "Importando"… */
  verbo?: string;
  expectativa?: string;
  consequencia?: string;
}) {
  const segundos = useSegundosDecorridos(ativo);
  if (!ativo) return null;
  return (
    <p role="status" aria-live="polite" style={{ color: "var(--text-muted)", marginTop: 10, fontSize: 13 }}>
      {verbo} há {fmtDecorrido(segundos)}. {expectativa} {consequencia}
    </p>
  );
}
